import type { Kit, RouterModel } from "@/types";

/**
 * What a kit's router has to be set to — K7, as a list a person can follow.
 *
 * The teacher's app applies these with one tap on a router it knows. This is
 * the same list on paper, for the router it does not know yet and for the day
 * the router's admin page has to be opened by hand. It is data rather than
 * prose so the app's profile and this checklist cannot say different things.
 */

export interface ChecklistItem {
  /** i18n key for the setting. */
  key: string;
  /** The value to enter, when there is one — shown verbatim, copyable. */
  value?: string;
}

/** The channels a kit uses on 2.4 GHz: the three that do not overlap. */
export const KIT_CHANNELS = [1, 6, 11] as const;

export const ROUTER_MODEL_LABEL_KEY: Record<RouterModel, string> = {
  "gl-mt3000": "kits.router.gl-mt3000",
};

export function routerChecklist(kit: Pick<Kit, "ssid" | "psk">): ChecklistItem[] {
  return [
    { key: "kits.checklist.ssid", value: kit.ssid },
    { key: "kits.checklist.psk", value: kit.psk },
    { key: "kits.checklist.band24" },
    { key: "kits.checklist.band5" },
    { key: "kits.checklist.isolation" },
    { key: "kits.checklist.internetCheck" },
    { key: "kits.checklist.noInternet" },
  ];
}
